import { useState } from "react";

const TYPE_LABEL_KEYS = {
    WORD_CLASSIFICATION: "typeWordClassification",
    WORD_DISCOVERY: "typeWordDiscovery",
    LESSON_REMINDER: "typeLessonReminder",
    CALENDAR_SYNC: "typeCalendarSync",
    PLANNED_EVENTS: "typePlannedEvents",
    CYCLED_LESSON_PROPAGATION: "typeCycledLessonPropagation",
    TELEGRAM_SEND: "typeTelegramSend",
};

function formatDate(dt) {
    return dt && dt.isValid ? dt.toFormat("dd.MM.yyyy HH:mm") : "";
}

export default function BackgroundHealthRow({ row, viewMode, t }) {
    const [expanded, setExpanded] = useState(false);
    const typeLabel = t[TYPE_LABEL_KEYS[row.type]] || row.type;
    const levelLabel = row.level === "INFO" ? t.levelInfo : row.level === "WARNING" ? t.levelWarning : t.levelError;
    const hasDetails = !!row.details;

    return (
        <li className="bg-health-row">
            <span className={"bg-health-level " + row.level.toLowerCase()}>{levelLabel}</span>
            <span className="bg-health-type-badge">{typeLabel}</span>
            <div className="bg-health-main">
                <div
                    className={"bg-health-message" + (hasDetails ? " bg-health-message-clickable" : "")}
                    onClick={() => hasDetails && setExpanded((v) => !v)}
                >
                    {row.message}
                    {hasDetails ? <span className="bg-health-expand-hint">{expanded ? "▲" : "▼"}</span> : ""}
                </div>
                {expanded && hasDetails ? <pre className="bg-health-details">{row.details}</pre> : ""}
            </div>
            {viewMode === "aggregated" ? (
                <div className="bg-health-count">
                    <span className="bg-health-count-badge">×{row.occurrenceCount}</span>
                    <span className="bg-health-time">
                        {t.lastSeen}: {formatDate(row.lastOccurredAt)}
                    </span>
                </div>
            ) : (
                <span className="bg-health-time">{formatDate(row.timestamp)}</span>
            )}
        </li>
    );
}
